function EmptyBox({ style }) {
	return <div className="empty_box" style={{}} />;
}

export default EmptyBox;
